import { render, staticRenderFns } from "./UiCommentForm.vue?vue&type=template&id=4fee101c&lang=pug&"
import script from "./UiCommentForm.vue?vue&type=script&lang=js&"
export * from "./UiCommentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports